import mocks from '@/payloads/aws/lambda/functions.js';
import { cognitoMixins } from '@storm/mixins/cognito';

const mixins = process.env.ADMIN === 'storm' ? [cognitoMixins] : [];

export default {
  mixins,
  methods: {
    async _lambdaInvokeFn(p) {
      const LIGHTNING = `${process.env.LAMBDA_PROXY}:${process.env.LAMBDA_PROXY_VERSION}`;
      const params = {
        FunctionName: LIGHTNING,
        InvocationType: 'RequestResponse',
        Payload: p.payload,
        LogType: 'None',
      };
      if ((this._dev && !this._useStaging && !this._storm) || this.$demo) {
        // this needs to be set and imported in main.js
        // import awsLocal from '@/mixins/aws/api.dev';
        // const lambda = new this.$aws_dev.Lambda();
        // return lambda.invoke(params).promise()
        return this._getDevResponse(p);
      }
      // check for expired sessions first
      await this._cognitoCheckSession();

      if (this._storm) {
        await this.checkStormSession();
        params.FunctionName = `${process.env.STORM_PROXY}:${process.env.STORM_PROXY_VERSION}`;
        const o = this._extractResponse(params.Payload);
        o.stormChosenUser = this.$store.getters.currentUser;
        params.Payload = JSON.stringify({
          stormChosenUser: this.$store.getters.currentUser,
          method: '$lightning',
          payload: {
            FunctionName: LIGHTNING,
            InvocationType: 'RequestResponse',
            Payload: o,
            LogType: 'None',
          },
        });
      }
      const lambda = new this.$aws.Lambda({ region: process.env.LAMBDA_REGION });
      return lambda.invoke(params).promise();
    },
    async _SEND(methods) {
      const call = await this._lambdaInvokeFn({
        payload: JSON.stringify({ methods }),
      });
      const response = this._extractResponse(call.Payload)[0];
      this._lambdaCheckErrors(response, call);
      return response;
    },
    _lambdaCheckErrors(p, call) {
      if (!p && call && call.FunctionError === 'Unhandled' && call.Payload) {
        const unhandled = this._extractResponse(call.Payload);
        throw new Error(unhandled.errorMessage);
      }
      const error = p !== null && p.errorMessage;
      if (error) {
        throw new Error(error);
      }
    },
    _extractResponse(p) {
      return typeof p === 'string' ? JSON.parse(p) : p;
    },
    _getDevResponse(params) {
      const methods = JSON.parse(params.payload).methods;
      return new Promise((resolve) => {
        // we use a setTimeout so we can make sure loaders are
        // working ok visually
        setTimeout(() => {
          resolve(mocks[methods[0].name]);
        }, 500);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/aws/lambda.js